import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DownloadSharp } from "@mui/icons-material";
import { visuallyHidden } from "@mui/utils";
import { Button, CircularProgress } from "@mui/material";
import DonutChart from "./donutchart";
import TableDonutChart from "./tableDonutChart";
import SentimentLabel from "./SentimentLabel";
import ProfanityLabel from "./ProfanityLabel";
import Box from "./base/Box";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Case Name",
  },
  {
    id: "type",
    numeric: true,
    disablePadding: false,
    label: "Case Type",
  },
  {
    id: "owner",
    numeric: true,
    disablePadding: false,
    label: "Case Owner",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "score",
    numeric: true,
    disablePadding: false,
    label: "Sentiment Score",
  },
  {
    id: "no",
    numeric: true,
    disablePadding: false,
    label: "No. of Docs",
  },
  {
    id: "date",
    numeric: true,
    disablePadding: false,
    label: "Creation Date",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: "#0065c91A", height: '4px', borderBottom: "0.5px #E2E2E2 solid" }}>
        {/* {headCells.map((headCell) => ( */}
          {/* <TableCell */}
          {/*   key={headCell.id} */}
          {/*   align={"center"} */}
          {/*   sortDirection={orderBy === headCell.id ? order : false} */}
          {/* > */}
          {/*   <TableSortLabel */}
          {/*     active={orderBy === headCell.id} */}
          {/*     direction={orderBy === headCell.id ? order : "asc"} */}
          {/*     onClick={createSortHandler(headCell.id)} */}
          {/*   > */}
          {/*     {headCell.label} */}
          {/*     {orderBy === headCell.id ? ( */}
          {/*       <Box component="span" sx={visuallyHidden}> */}
          {/*         {order === "desc" ? "sorted descending" : "sorted ascending"} */}
          {/*       </Box> */}
          {/*     ) : null} */}
          {/*   </TableSortLabel> */}
          {/* </TableCell> */}
        {/* ))} */}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar>
      <Typography
        sx={{ flex: "1 1 100%", marginLeft: -1 }}
        variant="p"
        id="tableTitle"
        component="div"
      >
        Sentence Analysis 
      </Typography>

      <Tooltip title="Download .pdf">
        <Button 
          style={{ border: '0.5px #0065c9 solid', color: '#0065c9', minWidth: '200px', display: 'flex', gap: '20px' }}
          onClick={() => {
            window.open(props.url, "_blank"); 
          }}
        >
          <DownloadSharp /> Download .pdf
        </Button>
      </Tooltip>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function SentenceTable(props) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = [...props.rowData];


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    props.getPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const convertText = (text,profArr) => {
    let textArr = text ? text.split(" ") : [];
    let finalHtml = "<p>"
    for (const item of textArr) {
      if(profArr && profArr.length > 0 && profArr.includes(item)){
        finalHtml += ` <span style="color:red !important">${item}</span>`
      }
      else{
        finalHtml += ` ${item}`
      }
    }
    finalHtml += '</p>';
    return finalHtml;
  }
 

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%"}}>
      <Paper sx={{ width: "100%", mb: 2 , borderRadius: '18px', boxShadow: "0px 5px 15px #00000029" }}>
        <EnhancedTableToolbar numSelected={selected.length} url={props.url} />
        <TableContainer>
          <Table>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.sort(getComparator(order, orderBy)).slice() */}
              {props.loading ? 
              <Box sx={{marginY: '300px', overflow: 'hidden'}}>
                <CircularProgress
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center'
                  }} 
                />
              </Box> : stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      sx={{
                        '&.MuiTableRow-root:hover':{
                          backgroundColor: '#0065c933'
                        }
                      }} 
                      tabIndex={-1}
                      key={row._id}
                      selected={isItemSelected}
                    >
                      <TableCell align="" style={{ minWidth: '320px'}}>
                        <div 
                          style={{
                            color: '#776a7a',
                            marginBottom: '11px'
                          }}
                        >
                          {/* Disabled Paragraph */}
                          {/* {`Paragraph ${row._source.para_number}; Line ${row._source.line_number}`} */}
                          {`Sentence ${row._source.line_number}`}
                        </div>
                        <div
                          style={{
                            color: '#402E46'
                          }}
                        >
                          {/* {row._source.profane_words} */}
                          <div dangerouslySetInnerHTML={{ __html: convertText(row._source.sentence_text,row._source.profane_words) }} />
                          {/* {convertText(row._source.sentence_text,row._source.profane_words)} */}
                          {/* {row._source.sentence_text} */}
                        </div>
                      </TableCell>
                      
                      <TableCell align="center">
                        <Box textAlign='center'>Sentiment</Box>
                        <SentimentLabel sentiment={row._source.sentiment_label} component='p' sx={{marginX: 'auto'}} />
                      </TableCell>

                      <TableCell align="center">
                        <div>Profanities</div>
                        <ProfanityLabel value={row._source.profanity} sx={{marginX: 'auto'}} component="p" />
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={props.totalRows}
          rowsPerPage={rows.length}
          page={props.currentPage - 1 }
          onPageChange={handleChangePage}
          labelDisplayedRows={(data) => {
            if (props.currentPage == props.totalPages) {
              return `${(data.count - rows.length) + 1}-${data.count} of ${data.count}` 
            }
            else {
              return `${data.from}-${data.to} of ${data.count}` 
            }
          }}
          nextIconButtonProps={
            props.totalPages > props.currentPage ? 
              undefined
            :
              {
                disabled: true
              }
          }
          // onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
